import { useLayoutEffect, useRef } from "react";
import { formatAmount } from "../utils";

// Counts the characters formatting keeps (digits and the decimal point).
const significant = (s) => s.replace(/[^0-9.]/g, "").length;

/**
 * Text input for money amounts that shows thousands separators while typing
 * ("20000" -> "20,000"). onChange receives the formatted string; `n()` parses
 * it back to a number. The caret is kept next to the same digit after
 * commas are inserted or removed.
 */
const AmountInput = ({ value, onChange, ...rest }) => {
  const ref = useRef(null);
  const caret = useRef(null);
  const shown = formatAmount(value);

  useLayoutEffect(() => {
    const el = ref.current;
    if (caret.current == null || !el || document.activeElement !== el) return;
    let seen = 0;
    let pos = 0;
    while (pos < shown.length && seen < caret.current) {
      if (/[0-9.]/.test(shown[pos])) seen += 1;
      pos += 1;
    }
    el.setSelectionRange(pos, pos);
    caret.current = null;
  });

  return (
    <input
      {...rest}
      ref={ref}
      value={shown}
      inputMode="decimal"
      onChange={(e) => {
        const raw = e.target.value;
        caret.current = significant(raw.slice(0, e.target.selectionStart ?? raw.length));
        onChange(formatAmount(raw));
      }}
    />
  );
};

export default AmountInput;
